import serializeObject from '@arsenal/arsenal/modules/serializeObject'
import fetch from 'lib/decorated-fetch'
import getUrl from 'lib/url'

export interface ILogPb {
  channel_id: null
  impr_id: string
}
export interface IDiscussLabel {
  open_url: string
  activity_flag: null
  concern_source: null
  image: null
  desc: null
  concern_id: number
  name: string
}
export interface ICommunityInfo {
  motor_name: string
  open_url: string
  motor_type: number
  motor_id: number
}
export interface IRepostInfo {
  name: string
  sync_thread: boolean
  title: string
  ui_style: number
  item_id: number
  image_url: string
  item_id_str: string
  community_info: ICommunityInfo
  scheme: string
}
export interface IMotorAuthShowInfo {
  answer_ans_num: number
  answer_medal_url: string
  car_identity_desc: string
  answer_invited_num: number
  answer_medal_desc_url: string
  auth_v_desc: string
  auth_v_type: number
  answer_digg_num: number
}
export interface IUserInfo {
  user_id: number
  name: string
  live_info: null
  description: string
  motor_auth_show_info: IMotorAuthShowInfo
  verified_content: string
  avatar_url: string
  medal_list: null
  follower_count: number
  follow: boolean
  user_auth_info: string
  user_verified: boolean
  schema: string
}
export interface IQuestionInfo {
  status: number
  adopted_id: number
  send_award: string
  award_icon_url: string
  status_display: string
  participated: string
}
export interface IAppImprInfo {
  sub_style: number
  style: number
}
export interface IActionList {
  action: number
  desc: null
  extra_str: null
}
export interface IShareInfo {
  share_text: string
  title: string
  weixin_special_type: number
  weixin_share_schema: string
  share_url: string
  special_share_doc: string
  share_image: string
}
export interface IUrlList {
  url: string
}
export interface IDefaultImageList {
  url: string
  url_list: IUrlList[]
  uri: string
  height: number
  width: number
  type: null
}
export interface IAutoLabel {
  open_url: string
  activity_flag: null
  concern_source: null
  image: null
  desc: null
  concern_id: number
  name: string
}
export interface IMotorIdentityInfo {
  digg_num: number
  medal_desc_url: string
  ans_num: number
  answerer_medal_pop_url: string
  car_identity_desc: string
  answerer_identity_desc: string
  invited_num: number
  answerer_medal_url: string
  cheyou_master_identity_desc: string
  identity_desc: string
  identity: string
}
export interface IStructuredInfo {
  duration_desc: string
  bought_time_desc: string
  display_car_name: string
  extra_info: []
}
export interface IKoubeiInfo {
  is_from_key_frame: boolean
  structured_info: IStructuredInfo
  sub_count_title: string
  recommend_level: number
  recommend_icon: string
  is_recommended: boolean
  audit_status: number
  tag_info_list:
    | {
        Id: number
        TagName: string
      }[]
    | undefined
}
export interface IInfo {
  log_pb: ILogPb
  open_url: string
  behot_time: number
  activity_label: null
  blank_type: number
  image_list: {
    url: string
  }[]
  read_count: number
  digg_count: number
  thread_id: number
  discuss_label: IDiscussLabel
  share_url: string
  comment_cells: null
  video_thumb_url: null
  video_duration: number
  repost_info: IRepostInfo
  user_verified: boolean
  article_labels: null
  aggr_type: number
  dislike_info: null
  link_info: null
  title: string
  image_type: number
  folded: boolean
  comment_count: number
  content_rich_span: string
  motor_top_article: boolean
  content: string
  user_info: IUserInfo
  duplicate: boolean
  question_info: IQuestionInfo
  recommend_reason: string
  share_count: number
  poi_list: null
  app_impr_info: IAppImprInfo
  display_time: number
  video_detail_info: null
  action_list: IActionList[]
  wap_display_url: string
  poi_label: null
  share_info: IShareInfo
  motor_koubei_info: IKoubeiInfo
  comment_list: null
  large_image_list: null
  product_label: null
  user_digg: boolean
  activity_theme: null
  abstract_content: string
  operation_status: number
  video_id: null
  thread_type: number
  label: string
  default_image_list: IDefaultImageList[]
  head_label: null
  cursor: number
  product_list: null
  auto_label: IAutoLabel
  motor_identity_info: IMotorIdentityInfo
  motor_car_info: null
  source: string
  publish_time: number
}
export interface IFeedData {
  info: IInfo
  duplicate: boolean
  type: number
  unique_id: number
  unique_id_str: string
}

interface FeedListParams {
  motor_id: number
  series_id?: string
  tab: string
  min_behot_time?: number
  max_behot_time?: number
  max_cursor?: number
  type?: string
}

export default async (opt: FeedListParams) => {
  const {
    type = 'enter_auto',
    motor_id = '',
    tab = '',
    min_behot_time = 0,
    max_behot_time = 0,
    max_cursor = 0,
    series_id = 0,
  } = opt || {}

  const koubeiParams = {
    aid: 1839,
    motor_feed_extra_params: {
      new_feed: true,
      feed_type: 0,
    },
    sort_type: 1,
    tt_from: type,
    count: 10,
    series_id,
    tag_id: 0,
    car_id: 0,
    impression_info: {
      page_id: 'page_user_profile',
    },
    loc_mode: 1,
    refer: 2,
    tag_name: '推荐',
    max_cursor,
    version_code: '6.1.5',
    device_platform: 'iphone',
  }

  if (tab === 'koubei') {
    const { data } = await fetch(
      getUrl(
        `${`/motor/koubei_api/koubei_list_v2`}?${serializeObject(koubeiParams)}`
      )
    )
    return data
  }

  const params = {
    motor_id,
    channel: 'm_web',
    device_platform: 'wap',
    category: tab,
    cmg_flag: tab,
    min_behot_time,
    max_behot_time,
    max_cursor,
    web_id: 0,
    device_id: 0,
    impression_info: JSON.stringify({
      page_id: 'page_forum_home',
      product_name: 'pc',
    }),
    tt_from: type,
    source: 'pc',
    _t: Date.now(),
  }

  // cmg_flag 为 wenda 时 替换为 series_wenda_publish
  if (params?.cmg_flag === 'wenda') {
    params.cmg_flag = 'series_wenda_publish'
  }

  const { data } = await fetch(
    getUrl(
      `${
        tab === 'recommend'
          ? '/motor/stream_entrance/get_feed/v47/'
          : '/motor/discuss_ugc/cheyou_feed_list_v3/v1/'
      }?${serializeObject(params)}`
    )
  )
  return data
}
